import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ANIMATION_TYPES;

(function (ANIMATION_TYPES) {
  ANIMATION_TYPES["NONE"] = "";
  ANIMATION_TYPES["FADE_IN"] = "animate-fade-in";
  ANIMATION_TYPES["SLIDE_DOWN_FADE_IN"] = "animate-slide-down-fade-in";
  ANIMATION_TYPES["EASE_IN_BG"] = "animate-ease-in-bg";
  ANIMATION_TYPES["SLIDE_IN"] = "animate-slide-in";
  ANIMATION_TYPES["SLIDE_IN_FADE_IN"] = "animate-slide-in-fade-in";
})(ANIMATION_TYPES || (ANIMATION_TYPES = {}));

export var AnimatedContainer = function AnimatedContainer(_ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$animationType = _ref.animationType,
      animationType = _ref$animationType === void 0 ? '' : _ref$animationType,
      className = _ref.className,
      children = _ref.children,
      delay = _ref.delay;
  return /*#__PURE__*/_jsx(Component, {
    className: classNames(className, _defineProperty({}, animationType, animationType)),
    style: animationType ? {
      '--animation-delay': delay
    } : undefined,
    children: children
  });
};